import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=8f3aeb60&scoped=true&"
import script from "./AlarmInfo.vue?vue&type=script&lang=js&"
export * from "./AlarmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3aeb60",
  null
  
)

export default component.exports